import React, { useLayoutEffect, useRef, useState } from "react"
import Layout from "../components/layout"
import TransitionLink from 'gatsby-plugin-transition-link'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { StaticImage } from "gatsby-plugin-image"
import Footer from "../components/footer"
import chevronDown from "../images/angle-down.svg"
import prevImage from "../images/double-profile-rev.jpg"
import nextImage from "../images/Hero_04_Operations_REV.jpg"
import prevRings from "../images/RINGS_MAGENTA_YELLOW.svg"
import nextRings from "../images/RINGS_MAGENTA_YELLOW.svg"
import arrowLeft from "../images/yellow-arrow.svg"
import { Link } from "gatsby"
import ringsgy from "../images/RINGS_GREEEN_YELLOW.svg"
import ringsmy from "../images/RINGS_MAGENTA_YELLOW.svg"
import ringscy from "../images/RINGS_CYAN_YELLOW.svg"
import ringsbm from "../images/RINGS_BLUE_MAGENTA.svg"
import ringsby from "../images/RINGS_BLUE_YELLOW.svg"

import "../components/pages.scss"

gsap.registerPlugin(ScrollTrigger);

const OfficersPage = (props) => {
    const firstRow = useRef();
    const circles = useRef([]);
    const navList = useRef();

    useLayoutEffect(() => {
        console.log(circles);
        for(let x = 0; x < circles.current.length; x++) {
            gsap.to(circles.current[x], {
                x: (i, target) => -1000 * target.dataset.speed,
                ease: "none",
                scrollTrigger: {
                    trigger: circles.current[x],
                    scrub: true,
                }
            });
        }

        gsap.from(navList.current, {
            y: "-100%",
            duration: .35,
            ease: "power2"
        });
    }, []);

    function exitAnimation(exit, node, int) {
        gsap.to(navList.current, {
            y: "-100%",
            duration: .35,
            ease: "power2"
        });
    }

    return (
        <Layout>
            <main className="page officers">
                <title>Officers</title>
                <div className="row nav">
                    <div className="col-xs-12">
                        <nav>
                            <ul ref={navList}>
                                <li>
                                    <Link
                                        className="back-button"
                                        activeClassName="active"
                                        to="/"
                                        state={{ pageId: 2 }}
                                    >
                                        <img src={arrowLeft} alt=""/>
                                    </Link>
                                </li>
                                <li className="blue-bar">|</li>
                                <li data-url="officers" className="text--yellow">Officers</li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div className="page-set">
                    <div className="wrapper">
                        <div className="container">
                            <section className="panel">
                                <div className="wrap">
                                    <div className="profile">
                                        <StaticImage loading="eager" objectFit="contain" placeholder="blurred" quality="50" className="avatar" src="../images/Hero_Officers.jpg" alt="" />
                                        <img className="rings" src={ringsby} alt="" /> 
                                    </div>
                                    <div className="info">
                                        <div className="title--super text--outline">MAKING AN</div>
                                        <h1>IMPACT</h1>
                                        <div className="button-wrap">
                                            <TransitionLink
                                                className="button"
                                                to="/"
                                                exit={{
                                                    
                                                }}
                                                entry={{
                                                }}
                                            >
                                                Read Welcome
                                            </TransitionLink>
                                        </div>
                                    </div>
                                    <img className="chevron-down" src={chevronDown} alt="" />
                                </div>
                                <div 
                                    className="circle--blue top"
                                    ref={(element) => circles.current[0] = element}
                                    data-speed=".3"
                                ></div>
                                <div
                                    className="circle--pink top" 
                                    ref={(element) => circles.current[1] = element}
                                    data-speed="-.1"
                                ></div>
                                <div
                                    className="circle--green top" 
                                    ref={(element) => circles.current[2] = element}
                                    data-speed=".7"
                                ></div>
                                <div
                                    className="circle--yellow top" 
                                    ref={(element) => circles.current[3] = element}
                                    data-speed=".5"
                                ></div>
                            </section>
                        </div>
                    </div>
                </div>
                <div className="composite-container rel z10">
                    <div className="row row-wrapper first-row content" ref={firstRow}>
                       <div className="col-xs-12">
                            <StaticImage layout="fullWidth" objectFit="contain" className="composite-group" src="../images/Composite_Group_REV.png" alt="" />
                       </div>
                    </div>
                </div>
                <div className="bg-blue">
                    <div className="row row-wrapper">
                        <div className="col-xs-12">
                            <div className="text--white">
                                <div className="text text--white text-box">
                                    <p className="text--white text--bold text--large"><span className="text--bold text--uppercase text--yellow">Left to Right:</span> MICHAEL BRYSON, Senior Vice President – Operations; THOMAS F. O’BRIEN, Senior Vice President & Chief Information Officer; LISA&nbsp;M.&nbsp;DRAUSCHAK, Vice President, Chief Financial Officer & Treasurer; CHRISTOPHER O’HARA, Senior Vice President, General Counsel, Law & Chief Compliance Officer; MANU ASTHANA, President & CEO; ASIM Z. HAQUE, Vice President – State & Member Services; FREDERICK S. BRESLER&nbsp;III, Senior Vice President – Market Services; KENNETH S. SEILER, Vice President – Planning; NORA SWIMM, Senior Vice President – Corporate Client Services</p>
                                    <p className="text--white text--bold text--large text--italic">COVID-19 precautions were observed in the creation of this image. This is a composite image of individually taken photos.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer 
                nextLink="/operations" 
                nextTitle="Operations"
                nextText="Next &gt;"
                nextButton="Read More" 
                nextImage={nextImage} 
                nextRings={nextRings} 
                prevLink="/board-ceo-letters"
                prevTitle="Board & CEO Letters"
                prevText="&lt; Previous"
                prevButton="Read More" 
                prevImage={prevImage} 
                prevRings="" 
            />
        </Layout>
    )
}

export default OfficersPage
